// // src/components/CategoryClasses.jsx

// import React, { useContext } from "react";
// import { useParams, Link } from "react-router-dom";
// import "../styles/CategoryClasses.css"; // Создайте CSS файл для стилизации
// import Loader from "./Loader";
// import { ClassContext } from '../contexts/ClassContext';
// import { CategoryContext } from '../contexts/CategoryContext';

// const CategoryClasses = () => {
//     const { id } = useParams(); // Получаем ID категории из URL
//     const { klassen, loadingKlassen, errorKlassen } = useContext(ClassContext);
//     const { kategorien, loadingKategorien, errorKategorien } = useContext(CategoryContext);

//     if (loadingKlassen || loadingKategorien) {
//         return <Loader />;
//     }

//     if (errorKlassen || errorKategorien) {
//         return (
//             <div>
//                 {errorKlassen && <p className="error">{errorKlassen}</p>}
//                 {errorKategorien && <p className="error">{errorKategorien}</p>}
//             </div>
//         );
//     }

//     // Находим категорию по ID для отображения её названия
//     const category = kategorien.find(kategorie => kategorie.id.toString() === id);
//     const categoryName = category ? category.Name : "Kategorie nicht gefunden";

//     // Фильтруем классы по ID категории
//     const filteredKlassen = klassen.filter(klasse => {
//         // Предполагается, что класс имеет поле Kategorie с объектом и полем id
//         return klasse.Kategorie && klasse.Kategorie.id.toString() === id;
//     });

//     if (filteredKlassen.length === 0) {
//         return (
//             <div className="category-classes">
//                 <h1>Klassen in Kategorie: {categoryName}</h1>
//                 <p>Keine Klassen in dieser Kategorie gefunden.</p>
//             </div>
//         );
//     }

//     return (
//         <div className="category-classes">
//             <Link to="/" className="back-button">← Zurück</Link>
//             <h1 className="title">
//                 Hier findest du alle <br /> <span>Klassen für die Kategorie {categoryName} im Detail</span>
//             </h1>
//             <div className="cards3">
//                 {filteredKlassen.map((klasse) => (
//                     <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
//                         <div className="card-wrapper3">
//                             <div className="card3">
//                                 {/* Отображение иконки */}
//                                 {klasse.Icon && klasse.Icon.filename_disk ? (
//                                     <img
//                                         src={`${process.env.REACT_APP_API_BASE_URL}/assets/${klasse.Icon.filename_disk}`}
//                                         alt={klasse.Name}
//                                         className="klasse-icon"
//                                         loading="lazy"
//                                         onError={(e) => {
//                                             e.target.onerror = null;
//                                             e.target.src = "/images/placeholder.png";
//                                         }}
//                                     />
//                                 ) : (
//                                     <div className="klasse-icon-placeholder">No Icon</div>
//                                 )}
//                                 <p>
//                                     {klasse.Name}
//                                     <br />
//                                     <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
//                                         {klasse.icon_text}
//                                     </span>
//                                 </p>
//                             </div>
//                         </div>
//                     </Link>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default CategoryClasses;

// src/components/CategoryClasses.jsx

// import React, { useContext } from "react";
// import { useParams, Link } from "react-router-dom";
// import "../styles/CategoryClasses.css"; // Убедитесь, что этот файл существует и содержит необходимые стили
// import Loader from "./Loader"; // Если глобальный лоадер уже настроен, можно оставить
// import { ClassContext } from '../contexts/ClassContext';
// import { CategoryContext } from '../contexts/CategoryContext';

// const CategoryClasses = () => {
//     const { id } = useParams(); // Получаем ID категории из URL
//     const { klassen, loadingKlassen, errorKlassen } = useContext(ClassContext);
//     const { kategorien, loadingKategorien, errorKategorien } = useContext(CategoryContext);

//     if (loadingKlassen || loadingKategorien) {
//         return <Loader />;
//     }

//     if (errorKlassen || errorKategorien) {
//         return (
//             <div>
//                 {errorKlassen && <p className="error">{errorKlassen}</p>}
//                 {errorKategorien && <p className="error">{errorKategorien}</p>}
//             </div>
//         );
//     }

//     // Находим категорию по ID для отображения её названия
//     const category = kategorien.find(kategorie => kategorie.id.toString() === id);
//     const categoryName = category ? category.Name : "Kategorie nicht gefunden";

//     // Фильтруем классы по ID категории
//     const filteredKlassen = klassen.filter(klasse => {
//         // Предполагается, что класс имеет поле Kategorie с объектом и полем id
//         return klasse.Kategorie && klasse.Kategorie.id.toString() === id;
//     });

//     if (filteredKlassen.length === 0) {
//         return (
//             <div className="category-classes">
//                 <Link to="/" className="back-button">← Zurück</Link>
//                 <h1 className="title">
//                     Hier findest du alle <br /> <span>Klassen für die Kategorie {categoryName} im Detail</span>
//                 </h1>
//                 <p>Keine Klassen in dieser Kategorie gefunden.</p>
//             </div>
//         );
//     }

//     // Функция для формирования URL иконки
//     const getIconUrl = (icon) => {
//         if (!icon || !icon.filename_disk) return null;
//         const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//         return `${baseUrl}${icon.filename_disk}`;
//     };

//     return (
//         <div className="category-classes">
//             <Link to="/" className="back-button">← Zurück</Link>
//             <h1 className="title">
//                 Hier findest du alle <br /> <span>Klassen für die Kategorie {categoryName} im Detail</span>
//             </h1>
//             <div className="category-content">
//                 {/* Разделяем классы на три группы */}
//                 {(() => {
//                     // Фильтрация классов по Unterkategorie
//                     const standardClasses = filteredKlassen.filter(klasse => klasse.Unterkategorie === 'none');
//                     const zusatzClasses = filteredKlassen.filter(klasse => klasse.Unterkategorie === 'zusatz');
//                     const anhaengerClasses = filteredKlassen.filter(klasse => klasse.Unterkategorie === 'anhaenger');

//                     return (
//                         <>
//                             {/* Стандартные классы */}
//                             {standardClasses.length > 0 && (
//                                 <div className="classWrap">
//                                     {/* <h2 className="class-title">{categoryName}</h2> */}
//                                     <div className="cards3">
//                                         {standardClasses.map((klasse) => (
//                                             <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
//                                                 <div className="card-wrapper3">
//                                                     <div className="card3">
//                                                         {/* Отображение иконки */}
//                                                         {klasse.Icon && klasse.Icon.filename_disk ? (
//                                                             <img
//                                                                 src={getIconUrl(klasse.Icon)}
//                                                                 alt={klasse.Name}
//                                                                 className="klasse-icon"
//                                                                 loading="lazy"
//                                                                 onError={(e) => {
//                                                                     e.target.onerror = null;
//                                                                     e.target.src = "/images/placeholder.png";
//                                                                 }}
//                                                             />
//                                                         ) : (
//                                                             <div className="klasse-icon-placeholder">No Icon</div>
//                                                         )}
//                                                         <p>
//                                                             {klasse.Name}
//                                                             <br />
//                                                             <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
//                                                                 {klasse.icon_text}
//                                                             </span>
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </Link>
//                                         ))}
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Zusatzausbildungen */}
//                             {zusatzClasses.length > 0 && (
//                                 <div className="classWrap">
//                                     <h2 className="zusatz-anhaenger-class">Zusatzausbildungen</h2>
//                                     <div className="cards3">
//                                         {zusatzClasses.map((klasse) => (
//                                             <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
//                                                 <div className="card-wrapper3">
//                                                     <div className="card3">
//                                                         {/* Отображение иконки */}
//                                                         {klasse.Icon && klasse.Icon.filename_disk ? (
//                                                             <img
//                                                                 src={getIconUrl(klasse.Icon)}
//                                                                 alt={klasse.Name}
//                                                                 className="klasse-icon"
//                                                                 loading="lazy"
//                                                                 onError={(e) => {
//                                                                     e.target.onerror = null;
//                                                                     e.target.src = "/images/placeholder.png";
//                                                                 }}
//                                                             />
//                                                         ) : (
//                                                             <div className="klasse-icon-placeholder">No Icon</div>
//                                                         )}
//                                                         <p>
//                                                             {klasse.Name}
//                                                             <br />
//                                                             <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
//                                                                 {klasse.icon_text}
//                                                             </span>
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </Link>
//                                         ))}
//                                     </div>
//                                 </div>
//                             )}

//                             {/* Anhänger */}
//                             {anhaengerClasses.length > 0 && (
//                                 <div className="classWrap">
//                                     <h2 className="zusatz-anhaenger-class">Anhänger</h2>
//                                     <div className="cards3">
//                                         {anhaengerClasses.map((klasse) => (
//                                             <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
//                                                 <div className="card-wrapper3">
//                                                     <div className="card3">
//                                                         {/* Отображение иконки */}
//                                                         {klasse.Icon && klasse.Icon.filename_disk ? (
//                                                             <img
//                                                                 src={getIconUrl(klasse.Icon)}
//                                                                 alt={klasse.Name}
//                                                                 className="klasse-icon"
//                                                                 loading="lazy"
//                                                                 onError={(e) => {
//                                                                     e.target.onerror = null;
//                                                                     e.target.src = "/images/placeholder.png";
//                                                                 }}
//                                                             />
//                                                         ) : (
//                                                             <div className="klasse-icon-placeholder">No Icon</div>
//                                                         )}
//                                                         <p>
//                                                             {klasse.Name}
//                                                             <br />
//                                                             <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
//                                                                 {klasse.icon_text}
//                                                             </span>
//                                                         </p>
//                                                     </div>
//                                                 </div>
//                                             </Link>
//                                         ))}
//                                     </div>
//                                 </div>
//                             )}
//                         </>
//                     );
//                 })()}
//             </div>
//         </div>
//     );
// };

// export default CategoryClasses;

// src/components/CategoryClasses.jsx

import React, { useContext } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "../styles/CategoryClasses.css"; 
import { ClassContext } from '../contexts/ClassContext';
import { CategoryContext } from '../contexts/CategoryContext';

const CategoryClasses = () => {
    const { id } = useParams(); // Получаем ID категории из URL / Abrufen der Kategorien-ID aus der URL

    const navigate = useNavigate(); // useNavigate

    const { klassen, loadingKlassen, errorKlassen } = useContext(ClassContext);
    const { kategorien, loadingKategorien, errorKategorien } = useContext(CategoryContext);

    if (loadingKlassen || loadingKategorien) {
        return null; // Возвращаем null, так как глобальный лоадер уже отображается / Rückgabe von null, da der globale Loader bereits angezeigt wird
    }

    if (errorKlassen || errorKategorien) {
        return (
            <div>
                {errorKlassen && <p className="error">{errorKlassen}</p>}
                {errorKategorien && <p className="error">{errorKategorien}</p>}
            </div>
        );
    }

    // Находим категорию по ID для отображения её названия / Finden der Kategorie anhand der ID, um deren Namen anzuzeigen
    const category = kategorien.find(kategorie => kategorie.id.toString() === id);
    const categoryName = category ? category.Name : "Kategorie nicht gefunden";

    // Фильтруем классы по ID категории (учитывая множественные категории) / Filtern der Klassen nach Kategorien-ID (unter Berücksichtigung mehrerer Kategorien)
    const filteredKlassen = klassen.filter(klasse => {
        return klasse.Kategorien && klasse.Kategorien.some(kategorieRelation => kategorieRelation.Kategorien_id?.id.toString() === id);
    });

    if (filteredKlassen.length === 0) {
        return (
            <div className="category-classes">
                {/* <Link to="/" className="back-button">← Zurück</Link> */}
                <button onClick={() => navigate(-1)} className="back-button">← Zurück</button> {/* back page */}

                <h1 className="title">
                    Hier findest du alle <br /> <span>Klassen im Detail</span>
                </h1>
                <p>Keine Klassen in dieser Kategorie gefunden.</p>
            </div>
        );
    }

    // Функция для формирования URL иконки / Funktion zur Erstellung der URL für das Icon
    const getIconUrl = (icon) => {
        if (!icon || !icon.filename_disk) return null;
        const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
        return `${baseUrl}${icon.filename_disk}`;
    };

    return (
        <div className="category-classes">
            {/* <Link to="/" className="back-button">← Zurück</Link> */}
            <header className="categories-header">
                <div class="container">
                    <button onClick={() => navigate(-1)} className="back-button">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--white)"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
                    </button> {/* back page */}
                    <h2>Hier findest du alle</h2>
                    <h1>Klassen im Detail</h1>
                </div>
            </header>
            <div className="category-content">
                {/* Разделяем классы на три группы / Aufteilen der Klassen in drei Gruppen */}
                {(() => {
                    // Фильтрация классов по Unterkategorie / Filtern der Klassen nach Unterkategorie
                    const standardClasses = filteredKlassen.filter(klasse => klasse.Unterkategorie === 'none');
                    const zusatzClasses = filteredKlassen.filter(klasse => klasse.Unterkategorie === 'zusatz');
                    const anhaengerClasses = filteredKlassen.filter(klasse => klasse.Unterkategorie === 'anhaenger');

                    return (
                        <>
                            {/* Стандартные классы / Standardklassen */}
                            {standardClasses.length > 0 && (
                                <div className="classWrap">
                                    <h2 className="zusatz-anhaenger-class">{categoryName}</h2>
                                    <div className="cards3">
                                        {standardClasses.map((klasse) => (
                                            <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
                                                <div className="card-wrapper3">
                                                    <div className="card3">
                                                        {/* Отображение иконки / Anzeige des Icons */}
                                                        {klasse.Icon && klasse.Icon.filename_disk ? (
                                                            <img
                                                                src={getIconUrl(klasse.Icon)}
                                                                alt={klasse.Name}
                                                                className="klasse-icon"
                                                                loading="lazy"
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = "/images/placeholder.png";
                                                                }}
                                                            />
                                                        ) : (
                                                            <div className="klasse-icon-placeholder">No Icon</div>
                                                        )}
                                                        <p>
                                                            {klasse.Name}
                                                            <br />
                                                            <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
                                                                {klasse.icon_text}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Zusatzausbildungen */}
                            {zusatzClasses.length > 0 && (
                                <div className="classWrap">
                                    <h2 className="zusatz-anhaenger-class">Zusatzausbildungen</h2>
                                    <div className="cards3">
                                        {zusatzClasses.map((klasse) => (
                                            <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
                                                <div className="card-wrapper3">
                                                    <div className="card3">
                                                        {/* Отображение иконки / Anzeige des Icons */}
                                                        {klasse.Icon && klasse.Icon.filename_disk ? (
                                                            <img
                                                                src={getIconUrl(klasse.Icon)}
                                                                alt={klasse.Name}
                                                                className="klasse-icon"
                                                                loading="lazy"
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = "/images/placeholder.png";
                                                                }}
                                                            />
                                                        ) : (
                                                            <div className="klasse-icon-placeholder">No Icon</div>
                                                        )}
                                                        <p>
                                                            {klasse.Name}
                                                            <br />
                                                            <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
                                                                {klasse.icon_text}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* Anhänger */}
                            {anhaengerClasses.length > 0 && (
                                <div className="classWrap">
                                    <h2 className="zusatz-anhaenger-class">Anhänger</h2>
                                    <div className="cards3">
                                        {anhaengerClasses.map((klasse) => (
                                            <Link to={`/details/${klasse.id}`} key={klasse.id} className="card-link">
                                                <div className="card-wrapper3">
                                                    <div className="card3">
                                                        {/* Отображение иконки / Anzeige des Icons */}
                                                        {klasse.Icon && klasse.Icon.filename_disk ? (
                                                            <img
                                                                src={getIconUrl(klasse.Icon)}
                                                                alt={klasse.Name}
                                                                className="klasse-icon"
                                                                loading="lazy"
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = "/images/placeholder.png";
                                                                }}
                                                            />
                                                        ) : (
                                                            <div className="klasse-icon-placeholder">No Icon</div>
                                                        )}
                                                        <p>
                                                            {klasse.Name}
                                                            <br />
                                                            <span style={{ color: "black", fontWeight: "400", fontSize: "0.875rem" }}>
                                                                {klasse.icon_text}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                    );
                })()}
            </div>
        </div>
    );
};

export default CategoryClasses;
